import { CONFIG } from 'config/config';

import styled from 'styled-components/macro';

export const FooterWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 50px;
	background-color: ${CONFIG.colors.primary};
	width: 100%;
	color: ${CONFIG.colors.white};
`;

export const FooterInner = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	margin: auto;
`;

export const Logo = styled.img`
	width: 80px;
`;
